import { useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from 'react-bootstrap';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleChangeDataShopsPage } from '../../../../redux/actions/pages/shops';
import { BASE_SITE, SHOPS_POST } from '../../../../apis'; 
import axios from "axios";
import * as qs from "querystring";
import BackIcon from '../../../../styles/images/back-without-bg.png';
import CardShop from "../main/cardShop";

const Shops = () => {

    const navigate = useNavigate();
    const { title, cat } = useParams();
    const dispatch = useDispatch();

    const { token } = useSelector(state => state.user);
    const { shops } = useSelector(state => state.shops);

    useEffect(() => {
        callApiGetShopDetails();
        // eslint-disable-next-line
    }, [Shops]);

    const callApiGetShopDetails = () => {
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'post',
            url: BASE_SITE + SHOPS_POST,
            data: qs.stringify({
                cat,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': (!!token ? token : '')
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    break;
                case 'ok':
                    dispatch(handleChangeDataShopsPage('shops', response.data.shops));
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
        });

    };

    const handleBackBtn = () => {
        navigate(-1);
    };


    return (
        <div id="shops-page">

            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1}><img src={BackIcon} alt="back" onClick={handleBackBtn} /></Col>
                <Col xs={10}><h4 className="text-center mb-0">{title}</h4></Col>
                <Col xs={1}></Col>
            </Row>

            <Row className="" style={{paddingLeft: "15px", paddingRight: "15px"}}>
            {                
                shops.map((item, key) => {
                    return(
                        <CardShop data={{item}} key={key} />
                    );
                })
            }
            </Row>

        </div>
    );
}

export default Shops;